export { default } from './ConsultationFormTertiary';
